import { render, staticRenderFns } from "./InitiativeReportRecursive.vue?vue&type=template&id=5f565398&"
import script from "./InitiativeReportRecursive.vue?vue&type=script&lang=js&"
export * from "./InitiativeReportRecursive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports